import {
  LAUNCH_PANEL_PATH,
  PUBLIC_PATH,
  SESSIONS_PATH,
} from '../../../../api/paths';
import { THIRTY_MINS_IN_SECONDS } from '../../../../utils/constants';
import { dcloudApi } from '../../../api';
import { TAGS } from '../../../api/constants';

export const publicLaunchPanelApi = dcloudApi.injectEndpoints({
  endpoints: (build) => ({
    getPublicLaunchPanel: build.query<
      LaunchPanelResponse,
      FetchPublicLaunchPanelArgs
    >({
      keepUnusedDataFor: THIRTY_MINS_IN_SECONDS,
      providesTags: [TAGS.LAUNCH_PANEL],
      query: ({ sessionUid, versionUid, publicAccessKey }) => ({
        method: 'get',
        suppressErrorToast: true,
        url: `${PUBLIC_PATH}${SESSIONS_PATH}/${sessionUid}/${LAUNCH_PANEL_PATH}?versionUid=${versionUid}&publicAccessKey=${publicAccessKey}`,
      }),
    }),
  }),
});

export const { useGetPublicLaunchPanelQuery } = publicLaunchPanelApi;
